<template>
  <div
    class="modal fade"
    :id="modalId"
    tabindex="-1"
    role="dialog"
    aria-labelledby="product-listing-filter-modal-label"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="product-listing-filter-modal-title">
            {{ title }}
          </h5>
        </div>
        <div class="modal-body text-start">
          <div class="my-4">
            <span class="style-field-label">Group By</span>
            <select
              id="product-group-by"
              class="form-select product-group-by-input w-100"
              v-model="groupBySelection"
            >
              <option value="section">
                Section
              </option>
              <option value="category">
                Category
              </option>
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export { Modal } from "bootstrap";
export default {
  name: "ProductListingFilterModal",
  props: {
    modalId: {
      type: String,
      default: 'product-listing-filter-modal-id',
    },
    title: {
      type: String,
      required: true,
    },
    groupBy: {
      type: String,
      required: true,
    }
  },
  computed: {
    groupBySelection: {
      set(value) {
        this.$emit("update:groupBy", value);
      },
      get() {
        return this.groupBy;
      },
    }
  }
};
</script>

<style lang="scss" scoped>
.product-group-by-input {
  height: 50px;
  border: 1px solid #adadad;
  padding: 0px 10px;
  display: flex;
  align-items: center;
  border-radius: 10px;
  flex: 1;
}
</style>